@if (loading()) {
    <div class="line-chart-container skeleton">
        <div class="skeleton-chart"></div>
    </div>
} @else {
    <div class="line-chart-container">
        <div class="chart" echarts [options]="chartOptions()"></div>

        @if (legendItems().length > 1) {
            <div class="legend">
                @for (item of legendItems(); track item.name) {
                    <button
                        type="button"
                        class="legend-item"
                        [class.legend-item--inactive]="!item.isActive"
                        [class.legend-item--no-data]="!item.hasData"
                        [disabled]="!item.hasData"
                        (click)="toggleSeriesVisibility(item.name)"
                    >
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span class="legend-label">{{ item.name }}</span>
                    </button>
                }
            </div>
        }
    </div>
}
